import { useAIPetDetailsAPI } from "@/app/hooks/api_hooks/customer_profile/useAIPetDetailsAPI";
import { SparklesIcon } from "@heroicons/react/24/solid";
import { useEffect } from "react";

const PET_TYPE_LABELS: Record<number, string> = {
  1: "Dog",
  2: "Cat",
};

const AIPetProfileCard: React.FC<{ userId?: string }> = ({ userId }) => {
  const { execute: fetchAIPetDetails, aiPetDetails } = useAIPetDetailsAPI();

  useEffect(() => {
    if (!userId) return;
    fetchAIPetDetails(userId);
  }, [userId, fetchAIPetDetails]);

  const tableHeader = ["Pet Name", "Age", "Breed", "Pet Type", "Deworming", "Vaccination", "Sterilisation"];
  const tableRows =
    aiPetDetails?.pets?.map((pet) => [
      pet?.name ?? "--",
      pet?.age ?? "--",
      pet?.breed ?? "--",
      pet?.pet_type_id ? PET_TYPE_LABELS[pet.pet_type_id] ?? "--" : "--",
      pet?.deworming_status ?? "--",
      pet?.vaccination_status ?? "--",
      pet?.sterilisation_status ?? "--",
    ]) ?? [];

  return (
    <div className="mt-2 px-2">
      <div className="my-4 flex items-center gap-2">
        <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-blue-50">
          <SparklesIcon className="h-4 w-4 text-purple-600" />
        </span>
        <p className="text-left text-sm font-sans font-bold text-gray-800">
          <span>AI Pet Profile</span>
        </p>
      </div>
      {tableRows?.length > 0 ? (
        <div className="mt-2 flow-root">
          <div className="bg-white rounded-lg">
            <table className="w-full border-separate border-spacing-x-0 border-spacing-y-0.5 bg-[#F5F5F5] rounded-xl px-[3px] pb-[1px]">
              <thead className="bg-[#F5F5F5] text-[#1F1F23] top-0 font-normal">
                <tr>
                  {tableHeader.map((key, index) => (
                    <th
                      key={`${key}:${index}`}
                      className="py-3 px-3 text-left whitespace-nowrap text-xs font-medium text-[#1F1F23] capitalize"
                    >
                      {key}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="overflow-hidden rounded-xl w-full">
                {tableRows.map((row, rowIndex) => (
                  <tr key={`pet-row:${rowIndex}`} className="group bg-white transition">
                    {row.map((value, index) => (
                      <td key={`value:${rowIndex}:${index}`} className="px-3 py-3 whitespace-nowrap text-xs font-normal text-[#1F1F23]">
                        {value}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <p className="mt-2 text-xs text-[#808DA0]">No AI pet profile details available.</p>
      )}
    </div>
  );
};

export default AIPetProfileCard;
